<template>
  <div class="credentials-list">
    <template v-if="invalidCredentialsList.length > 0">
      <credentials-settings-section-header title-text="חשבונות שצריך לעדכן" color="mustard"/>
      <div class="creds-card-wrapper" v-for="(source, index) in invalidCredentialsList" :key="source.credentialsId">
        <waiting-credentials-card v-if="source.sourceName === 'דיסקונט ישיר'" :source="source" />
        <renew-credentials-card v-else :source="source" :focus-on-load="index === 0"/>
      </div>
    </template>

    <div v-if="newCredentialsList.length > 0 || discountPendingCredentialsList.length > 0" ref="new">
      <credentials-settings-section-header title-text="חשבונות חדשים" color="coral"/>
      <div class="creds-card-wrapper" v-for="source in discountPendingCredentialsList" :key="source.credentialsId">
        <waiting-credentials-card :source="source" />
      </div>
      <div class="creds-card-wrapper" v-for="(source, index) in newCredentialsList" :key="source.credentialsId">
        <discount-new-credentials-card-flow v-if="source.sourceName === 'דיסקונט ישיר'" :source="source" />
        <multi-state-credentials-card v-else :source="source" :focus-on-load="index === 0"/>
      </div>
    </div>

    <template v-if="validCredentialsList.length > 0 || unvalidatedCredentialsList.length > 0">
      <credentials-settings-section-header title-text="חשבונות מחוברים" color="green"/>
      <div class="creds-card-wrapper" v-for="(source, index) in validCredentialsList" :key="source.credentialsId">
        <multi-state-credentials-card :source="source" :focus-on-load="index === 0"/>
      </div>
      <div class="creds-card-wrapper" v-for="(source, index) in unvalidatedCredentialsList" :key="source.credentialsId">
        <multi-state-credentials-card :source="source" :focus-on-load="index === 0"/>
      </div>
    </template>

    <credentials-settings-section-header title-text="יצירת חשבונות חדשים" color="black"/>
    <div class="add-new">
      <add-missing-credentials-card
        :disabled="false"
        :selectionText="'באיזה בנק החשבון?'"
        :title="'הוספת חשבון בנק'"
        :sourceType="'bank'"
        :scrollable="true"
        :addSource="createCredentialsCard"/>
    </div>

    <div class="add-new">
      <add-missing-credentials-card
        :disabled="false"
        :selectionText="'באיזו חב׳ אשראי החשבון?'"
        :title="'הוספת כרטיס אשראי'"
        :sourceType="'card'"
        :scrollable="false"
        :addSource="createCredentialsCard"/>
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex';
import RenewCredentialsCard from '../credentials-card/RenewCredentialsCard.vue';
import MultiStateCredentialsCard from '../credentials-card/MultiStateCredentialsCard.vue';
import AddMissingCredentialsCard from '../credentials-selection-card/AddMissingCredentialsCard.vue';
import WaitingCredentialsCard from '../credentials-card/discount/WaitingCredentialsCard.vue';
import DiscountNewCredentialsCardFlow from '../credentials-card/discount/DiscountNewCredentialsCardFlow.vue';
import CredentialsSettingsSectionHeader from './CredentialsSettingsSectionHeader.vue';
import Segment from '../../../Segment';
import ShowUnsupportedModalMixin from '../../../pages/responsive-pages/authenticated/unsupported-banks/ShowUnsupportedModalMixin.vue';

export default {
  name: 'CredentialsSettings',
  components: {
    CredentialsSettingsSectionHeader,
    RenewCredentialsCard,
    MultiStateCredentialsCard,
    AddMissingCredentialsCard,
    WaitingCredentialsCard,
    DiscountNewCredentialsCardFlow,
  },
  mixins: [ShowUnsupportedModalMixin],
  computed: {
    ...mapState('credentials', ['credentialsList']),
    ...mapGetters('credentials', ['invalidCredentialsList', 'newCredentialsList',
      'validCredentialsList', 'unvalidatedCredentialsList', 'discountPendingCredentialsList']),
  },
  methods: {
    ...mapActions('credentials', ['createCredentials']),
    async createCredentialsCard({ source }) {
      if (source.type === 'bank') {
        Segment.trackUserInteraction('BankNameClicked', { name: source.sourceName });
      } else {
        Segment.trackUserInteraction('CardNameClicked', { name: source.sourceName });
      }
      if (source.unsupported) {
        this.showUnsupportedPopup(source);
      } else {
        await this.createCredentialsAndScroll(source);
      }
    },
    async createCredentialsAndScroll(source) {
      await this.createCredentials({ sourceName: source.sourceName });
      const top = this.$refs.new.scrollHeight - 600;
      window.scroll({ top, left: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .credentials-list {
    @include responsive-padding;
    width: 100%;

    .title {
      @include title;
      margin-bottom: 10px;
    }

    .add-new, .creds-card-wrapper {
      margin-bottom: 16px;
    }
  }
</style>
